module.exports = __webpack_public_path__ + "static/dc-orlando-2-576b23a05341231ae609010e3ef5f7d3.jpg";